export enum TenantedDeploymentMode {
    Untenanted = "Untenanted",
    TenantedOrUntenanted = "TenantedOrUntenanted",
    Tenanted = "Tenanted",
}

export default TenantedDeploymentMode;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/tenantedDeploymentMode.ts